var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.style)?_c('div',{style:(_vm.style),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_c('div',{ref:"lavContainer",staticClass:"lav-container"},[(!_vm.loaded)?_vm._t("loader"):_vm._e()],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }